import { Loader2 } from 'lucide-react';
export const Loader = () => {
  return (
    <div className="grid h-screen m-0 place-items-center">
      <div>
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    </div>
  );
};
